import { Component, OnInit, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from '@app/@core/services/alert.service';
import { AuthService } from '@app/@core/services/auth.service';
import { Idle, DEFAULT_INTERRUPTSOURCES, SimpleExpiry } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';

@Component({
  selector: 'app-acknowledgment',
  standalone: false,
  templateUrl: './acknowledgment.component.html',
  styleUrl: './acknowledgment.component.scss'
})
export class AcknowledgmentComponent implements OnInit {
  checked: boolean = false;
  version: string;
  userId: string;
  submitStatus: string = "Continue";
  idleState: string = 'NOT_STARTED';
  timedOut = false;
  private idle: Idle;
  constructor(
    private authService: AuthService,
    private router: Router,
    private alertService: AlertService,
    private ngZone: NgZone,
    private keepalive: Keepalive
  ) {
    this.idle = new Idle(
      new SimpleExpiry(),
      this.ngZone,
      this.keepalive
    );

    this.watchIdleTime();
    this.idle.watch();
  }
  ngOnInit(): void {
    const token = sessionStorage.getItem('refreshToken');

    if (!token) {
      this.router.navigate(['/auth/login']);
      return;
    }
    const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    this.userId = sessionStorage.getItem('id') || userDetails?.id || '';
    this.version = sessionStorage.getItem('conf_aggrment_ver') || '1';
  }

  toggleButton() {
    const checkbox: any = document.getElementById('acknowledgment');
    const button: any = document.getElementById('continueBtn');
    if (checkbox.checked) {
      button.disabled = false;
    } else {
      button.disabled = true;
    }
  }
  handleContinue(): void {
    const checkbox: any = document.getElementById('acknowledgment');
    if (!checkbox.checked) {
      return;
    }
   
    this.authService
      .submitConfidentialityAgreement(this.userId, this.version, this.checked)
      .subscribe((res) => {
        if (res) {
          sessionStorage.setItem("acknowledgment", JSON.stringify(true));
          this.submitStatus = "Please wait ...";
          this.authService.navigateUser(this.userId, false);
          this.submitStatus = "Continue";
          this.alertService.success("Acknowledgment submitted successfully.");
        } else {
          this.submitStatus = "Continue";
          this.alertService.error("Failed to submit acknowledgment. Please try again.");
        }
      });

  }

  watchIdleTime() {
    if (sessionStorage.getItem('jwt-token')) {
      const idletimeoutsec = sessionStorage.getItem('idletimeoutsec') ? Number(sessionStorage.getItem('idletimeoutsec')) : 1800;
      this.idle.setIdle(idletimeoutsec);

      this.idle.setTimeout(5);

      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      this.idle.onIdleEnd.subscribe(() => {
        this.idleState = 'No Longer Idle';
      });

      this.idle.onTimeout.subscribe(() => {
        this.idleState = 'Timed out!';
        this.timedOut = true;
        this.authService.logout();
      });

      this.idle.onIdleStart.subscribe(() => {
        this.idleState = 'You have gone Idle';
      });

      this.idle.onTimeoutWarning.subscribe((countdown) => {
        this.idleState = 'You will time out in ' + countdown + 'seconds';
      });
    } else {
      this.idle.stop();
    }
  }
}
